export const gettingStartedSearchIndex = [
	{
		section: 'gettingStarted',
		title: 'Introduction',
		path: '/getting-started',
		summary: 'Dynamic Signal APIs are a robust set of REST APIs and JavaScript widgets',
		fields: 'API Keys Endpoints'
	},
	{
		section: 'gettingStarted',
		title: 'Server Authentication',
		path: '/getting-started/server-authentication',
		summary: `The Dynamic Signal REST APIs are authenticated using OAuth2 (RFC 6749). modeled on Client Credentials Grant flow. Twitter step-by-step walkthrough.
Encode access token and token secret into your basic credentials.
Post this token to /v1/oauth2/token authorize header /v1/oauth2/invalidate_token`,
		fields: 'step logging password secret transmit compromised response SSL HTTPS HTTP'
	},
	{
		section: 'gettingStarted',
		title: 'Client Authentication',
		path: '/getting-started/client-authentication',
		summary: `Users on the Dynamic Signal platform are authenticated using Access Tokens. You must make a POST call to /v1/login with the user's credentials, such as their email and password`,
		fields: 'step logging password secret transmit compromised response SSL HTTPS HTTP'
	},
	{
		section: 'gettingStarted',
		title: 'Common Objects',
		path: '/getting-started/common-objects',
		summary: 'VoiceStorm Management Console',
		fields: 'leaderboard post stream tag metadata user categorizing namespaces provider Facebook Twitter LinkedIn Instagram Tumblr WordPress Blogger'
	},
	{
		section: 'gettingStarted',
		title: 'Making a Request',
		path: '/getting-started/making-a-request',
		summary: `All Dynamic Signal API requests made by HTTPS. Requests GET read-only PUT POST query string x-www-form-urlencoded HTTP/1.1
HTTP 200 OK status code. If error, variety different error codes 401 (Unauthorized), 403 (Forbidden), 404 (Not Found), 500 (Server Error)
already_exists
invalid_endpoint
invalid_response
invalid_request
login_failed
not_found
not_logged_in
offline
server_error
success
unauthorized
pagination skip take total next
Your First Request ping`,
		fields: 'flexible sample json URL hello application arrays comma comma-separated parameters multiple HTTP 1.1 reason curl'
	},
	{
		section: 'gettingStarted',
		title: 'Rate Limiting',
		path: '/getting-started/rate-limiting',
		summary: 'The Dynamic Signal API is rate limited by both the calling user and the application itself. The exact limits are subject to change. If you encounter frequent rate limiting, please contact your customer service account manager.',
		fields: ''
	},
	{
		section: 'gettingStarted',
		title: 'Simple Tasks',
		path: '/getting-started/simple-tasks',
		summary: `We are going to request the profile on user 1000, our sample user. In addition to asking for the basic user, we are using the include property to ask for the user’s profile images and channels.
The next task we are going to demonstrate is how to get a post. Call the /v1/post API with the post GUID.
upload a user profile picture two methods. POST with a mime-multipart form browser SDK PUT`,
		fields: 'curl mime multipart HTTP response request headers body registration register invitation email key InvitationKey'
	},
	{
		section: 'gettingStarted',
		title: 'Post Routing',
		path: '/getting-started/post-routing',
		summary: `properly handle display posts from social shares, emails, other actions, configure routing URL`,
		fields: 'SEO-optimized URL slug SEO optimized'
	},
	{
		section: 'gettingStarted',
		title: 'JSON Data Types',
		path: '/getting-started/json-data-types',
		summary: 'VoiceStorm uses standard JSON data types bool Boolean true false int signed 32-bit integer number long 64-bit dateTime ISO8601 Date Time string JavaScript guid globally unique identifier double',
		fields: 'array syntax collection key/value key value pairs'
	},
	{
		section: 'gettingStarted',
		title: 'Image Formats',
		path: '/getting-started/image-formats',
		summary: 'Dynamic Signal API uses a standard representation of image sizes. We provide various scaled versions for optimal performance. You can pick the size closest to the size your need and scale up or down',
		fields: 'Original Box960 Box640 Box320 Box100 Box80 Box40 Square160 Square80 Square40 Square20'
	},
	{
		section: 'gettingStarted',
		title: 'CORS',
		path: '/getting-started/cors',
		summary: 'Cross Origin Resource sharing',
		fields: 'cors cross origin resource sharing trusted domains security xhr'
	}
]



// WEBPACK FOOTER //
// ./src/constants/gettingStartedSearchIndex.js